// src/useWidgetData.ts
import { registerWidget } from "@getvim/utils-vim-connect-communication";
import { useEffect, useState } from "react";
function useWidgetData() {
  const [data, setData] = useState();
  useWidgetDataListener(setData);
  return data;
}
function useWidgetDataListener(listener) {
  useEffect(() => {
    return registerWidget(listener);
  }, []);
}

// src/useWidgetEvent.ts
import { registerWidget as registerWidget2 } from "@getvim/utils-vim-connect-communication";
import { useEffect as useEffect2, useState as useState2 } from "react";
function useWidgetEvent(event, defaultValue) {
  const [data, setData] = defaultValue !== void 0 ? useState2(defaultValue) : useState2();
  useWidgetEventListener(event, setData);
  return data;
}
function useWidgetEventListener(event, listener) {
  useEffect2(() => {
    return registerWidget2((data) => {
      if ((data == null ? void 0 : data.type) === event) {
        listener(data.payload);
      }
    });
  }, []);
}

// src/useVimHubEvent.ts
import { useEffect as useEffect3, useState as useState3 } from "react";
var VIM_CONNECT_HUB_APP_OPENED = "vim-connect-hub-app-opened";
function useIsAppOpenInHub(widgetId, callback, initialState) {
  const [isAppOpen, setIsAppOpen] = useState3(initialState != null ? initialState : false);
  useEffect3(() => {
    if (callback) {
      callback(isAppOpen);
    }
  }, [isAppOpen]);
  useEffect3(() => {
    const handleEvent = (e) => {
      if (e.data.type === VIM_CONNECT_HUB_APP_OPENED) {
        if (e.data.payload.selectedApplicationId === widgetId) {
          setIsAppOpen(true);
          return;
        }
        setIsAppOpen(false);
      }
    };
    window.addEventListener("message", handleEvent);
    return () => {
      window.removeEventListener("message", handleEvent);
    };
  }, []);
  return isAppOpen;
}
export {
  useIsAppOpenInHub,
  useWidgetData,
  useWidgetDataListener,
  useWidgetEvent,
  useWidgetEventListener
};
//# sourceMappingURL=index.js.map
